/* eslint-disable import/prefer-default-export */

export function capitalize(string) {
  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
}



// WEBPACK FOOTER //
// ./src/util.js